import { AuthorDto, UpsertAuthorDto } from "@growth/dto";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { api } from "./api";

export const useAuthors = () =>
  useQuery({
    queryKey: ["authors"],
    queryFn: async () => (await api.get<AuthorDto[]>("/authors")).data,
  });

export const useSaveAuthor = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, ...input }: UpsertAuthorDto & { id?: string }) =>
      id
        ? (await api.patch<AuthorDto>(`/authors/${id}`, input)).data
        : (await api.post<AuthorDto>("/authors", input)).data,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["authors"] }),
  });
};

export const useDeleteAuthor = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.delete(`/authors/${id}`),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["authors"] });
      // Posts embed their author; refresh any cached bylines.
      void queryClient.invalidateQueries({ queryKey: ["posts"] });
    },
  });
};
